const getSubPeriods = (
  period: BonusPeriod | BonusTypes.BonusPeriod,
): Period[] | undefined =>
  'subPeriods' in period ? period.subPeriods : undefined;

/**
 * Flatten every sub-period (week) across all bonus periods into a single list,
 * each tagged with its parent period, sorted ascending by startDate — so a
 * period picker on a content surface can offer direct navigation to any week.
 * Returns undefined when no period carries sub-periods (the ordinary
 * single-window case), which callers use to fall back to listing the periods
 * themselves.
 */
const flattenBonusSubPeriods = (
  bonusPeriods: BonusPeriod[] | BonusTypes.BonusPeriod[],
):
  | { period: BonusPeriod | BonusTypes.BonusPeriod; subPeriod: Period }[]
  | undefined => {
  const all: {
    period: BonusPeriod | BonusTypes.BonusPeriod;
    subPeriod: Period;
  }[] = [];
  bonusPeriods.forEach((period) => {
    (getSubPeriods(period) ?? []).forEach((subPeriod) => {
      all.push({ period, subPeriod });
    });
  });
  if (all.length === 0) {
    return undefined;
  }
  return all.sort((a, b) =>
    a.subPeriod.startDate.localeCompare(b.subPeriod.startDate),
  );
};

export default flattenBonusSubPeriods;
